export default __webpack_public_path__ + "static/media/bg-desktop.39ffe167.jpg";